import { CaretDown } from '@phosphor-icons/react';
import { LIMITS } from '../../utils/validation';
import FormField, { ValidatedInput } from '../UI/FormField';

/**
 * TravelDetailsSection - Collapsible section for flight/transit specific fields
 * Contains: flight number, terminal, booking reference, check-in info, luggage allowance
 */
export default function TravelDetailsSection({ 
  eventData, 
  onChange, 
  errors = {},
  isExpanded, 
  onToggle,
  disabled = false,
}) {
  function handleChange(field, value) {
    onChange({ ...eventData, [field]: value });
  }

  return (
    <div 
      className="rounded-sm overflow-hidden"
      style={{ border: '1px solid var(--color-border-subtle)' }}
    >
      <button
        type="button"
        onClick={onToggle}
        className="w-full flex items-center justify-between p-3 transition-colors"
        style={{ 
          backgroundColor: 'var(--color-bg-surface)',
          color: 'var(--color-text-secondary)',
        }}
      >
        <span className="text-sm font-medium">
          Additional Travel Details
          <span style={{ color: 'var(--color-text-muted)', fontWeight: 400 }}> (optional)</span>
        </span>
        <CaretDown 
          size={16} 
          weight="bold"
          className={`transition-transform duration-200 ${isExpanded ? 'rotate-180' : ''}`}
        />
      </button>
      
      {isExpanded && (
        <div className="p-3 space-y-3" style={{ backgroundColor: 'var(--color-bg-canvas)' }}>
          <div className="grid grid-cols-2 gap-3">
            <FormField label="Flight/Service Number" error={errors.flight_number}>
              <ValidatedInput
                type="text"
                value={eventData.flight_number}
                onChange={(e) => handleChange('flight_number', e.target.value)}
                error={errors.flight_number}
                placeholder="EI123"
                maxLength={LIMITS.FLIGHT_NUMBER_MAX}
                disabled={disabled}
              />
            </FormField>
            <FormField label="Terminal" error={errors.terminal}>
              <ValidatedInput
                type="text"
                value={eventData.terminal}
                onChange={(e) => handleChange('terminal', e.target.value)}
                error={errors.terminal}
                placeholder="Terminal 2"
                maxLength={LIMITS.TERMINAL_MAX}
                disabled={disabled}
              />
            </FormField>
          </div>
          
          <FormField label="Booking Reference" error={errors.booking_reference}>
            <ValidatedInput
              type="text"
              value={eventData.booking_reference}
              onChange={(e) => handleChange('booking_reference', e.target.value)}
              error={errors.booking_reference}
              placeholder="ABC123"
              maxLength={LIMITS.BOOKING_REFERENCE_MAX}
              disabled={disabled}
            />
          </FormField>
          
          <FormField label="Check-in Information" error={errors.check_in_info}>
            <ValidatedInput
              type="text"
              value={eventData.check_in_info}
              onChange={(e) => handleChange('check_in_info', e.target.value)}
              error={errors.check_in_info}
              placeholder="Online check-in opens 24hrs before"
              maxLength={LIMITS.CHECK_IN_INFO_MAX}
              disabled={disabled}
            />
          </FormField>
          
          <FormField label="Luggage Allowance" error={errors.luggage_allowance}>
            <ValidatedInput
              type="text"
              value={eventData.luggage_allowance}
              onChange={(e) => handleChange('luggage_allowance', e.target.value)}
              error={errors.luggage_allowance}
              placeholder="1x 23kg checked, 1x 10kg carry-on"
              maxLength={LIMITS.LUGGAGE_ALLOWANCE_MAX}
              disabled={disabled}
            />
          </FormField>
        </div>
      )}
    </div>
  );
}
